import * as React from 'react';

import {
    getHumanReadableDueUnit,
    getHumanReadableSingularDueUnit,
} from 'nutshell-core/date-time/delays';

import {colors} from 'shells/colors/colors';
import {DescriptionIcon, ClockIcon, ContactIcon} from 'shells/icon';

import type {
    SalesAutomationTaskTemplate as SalesAutomationTaskTemplateFragment,
    SalesAutomationStepTemplate as SalesAutomationStepTemplateFragment,
    SalesAutomationAssignable as SalesAutomationAssignableFragment,
    TaskTemplateDueDate as TaskTemplateDueDateFragment,
    StepTemplateDueDate as StepTemplateDueDateFragment,
} from 'nutshell-graphql-types';

import {getHumanReadableDueFrom} from '../../forms/due-date-constants';

import {SalesAutomationCard} from './sales-automation-card';
import {SalesAutomationDraggableCard} from './sales-automation-draggable-card';

import styles from './todo-template-card.module.css';

type Props = {
    type: 'stepTemplates' | 'closedLeadTaskTemplates';
    index: number;
    isHidden?: boolean;
    parentId: string;
    todoTemplate: SalesAutomationStepTemplateFragment | SalesAutomationTaskTemplateFragment;
    isDraggable: boolean;
    isDragDisabled?: boolean;
};

/*
 * Component that represents a single step template card on the sales process.
 */
export class TodoTemplateCard extends React.PureComponent<Props> {
    render() {
        const {id, name, description, dueDate, assignee} = this.props.todoTemplate;

        const Card = this.props.isDraggable ? SalesAutomationDraggableCard : SalesAutomationCard;

        return (
            <Card
                parentId={this.props.parentId}
                isHidden={this.props.isHidden}
                isDragDisabled={this.props.isDragDisabled}
                type={this.props.type}
                entityId={id}
                index={this.props.index}
            >
                <div>
                    <div className={styles['title-container']}>
                        <span className={styles.name}>{name}</span>
                        {description ? (
                            <DescriptionIcon className={styles['description-icon']} />
                        ) : undefined}
                    </div>
                    {dueDate ? this.renderDueDateSection(dueDate) : undefined}
                    {assignee ? this.renderAssigneeSection(assignee) : undefined}
                </div>
            </Card>
        );
    }

    renderDueDateSection = (
        dueDate?: TaskTemplateDueDateFragment | StepTemplateDueDateFragment | null
    ) => {
        if (!dueDate) return null;
        const dueUnit =
            dueDate.dueTimespan === 1
                ? getHumanReadableSingularDueUnit(dueDate.dueUnit)
                : getHumanReadableDueUnit(dueDate.dueUnit);

        return (
            <div className={styles['due-date']}>
                <ClockIcon className={styles['clock-icon']} />
                {dueDate.__typename === 'StepDueDate'
                    ? `${dueDate.dueTimespan} ${dueUnit} ${getHumanReadableDueFrom(
                          dueDate.dueFrom
                      )}`
                    : `${dueDate.dueTimespan} ${dueUnit} after the lead is closed`}
            </div>
        );
    };

    renderAssigneeSection = (assignee?: SalesAutomationAssignableFragment | null) => {
        if (!assignee) return null;

        return (
            <div className={styles.assignee}>
                {/* @ts-expect-error */}
                <ContactIcon fill={colors.orange} className={styles['assignee-icon']} size={15} />
                {assignee.name}
            </div>
        );
    };
}
